import { BrowserRouter, Route, Routes } from "react-router-dom"
import { Layout } from "@/components/Layout"
import { PrivateRoute } from "@/components/auth/PrivateRoute"
import { RoleProtectedRoute } from "@/components/auth/RoleProtectedRoute"
import Profile from "@/pages/Profile"
import Settings from "@/pages/Settings"
import NewUser from "@/pages/NewUser"
import Login from "@/pages/Login"
import Index from "@/pages/Index"
import Documents from "@/pages/Documents"
import Instagram from "@/pages/Instagram"
import Users from "@/pages/Users"
import Error from "@/pages/Error"

export function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        
        {/* Protected routes wrapped in Layout */}
        <Route element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route path="/" element={<Index />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/documents" element={<Documents />} />
          <Route path="/instagram" element={<Instagram />} />
          
          {/* Admin-only routes */}
          <Route path="/settings" element={
            <RoleProtectedRoute allowedRoles={["admin"]}>
              <Settings />
            </RoleProtectedRoute>
          } />
          <Route path="/users" element={
            <RoleProtectedRoute allowedRoles={["admin"]}>
              <Users />
            </RoleProtectedRoute>
          } />
          <Route path="/users/new" element={
            <RoleProtectedRoute allowedRoles={["admin"]}>
              <NewUser />
            </RoleProtectedRoute>
          } />
        </Route>

        {/* 404 catch-all route */}
        <Route path="*" element={<Error />} />
      </Routes>
    </BrowserRouter>
  )
}